import { render } from "./rights.vue?vue&type=template&id=f0aee3d2&scoped=true"
import script from "./rights.vue?vue&type=script&lang=js"
export * from "./rights.vue?vue&type=script&lang=js"

import "./rights.vue?vue&type=style&index=0&id=f0aee3d2&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0aee3d2"]])

export default __exports__